// deps
import React from "react";

// internal deps
import { PreferredGroup } from "@swiggy-private/payment-ui";

// interfaces
import { PreferredGroupHandlerProps } from "@payment-client/components/show-payments/components/payment-group-handler/interfaces";

// hooks
import { usePreferredHandler } from "@payment-client/components/show-payments/components/payment-group-handler/hooks/UsePreferredHandler";

export function PreferredGroupHandler(props: PreferredGroupHandlerProps): React.ReactElement | null {
    const { onSelect, onPay, paymentGroup, ...otherProps } = props;
    const preferredProps = usePreferredHandler(props);

    return <PreferredGroup {...otherProps} {...preferredProps} />;
}
